import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.tsx'

const sentryDsn = import.meta.env.VITE_SENTRY_DSN
const isSentryConfigured = sentryDsn && sentryDsn.startsWith('https://') && sentryDsn.includes('sentry.io')

// Sentry — only active in production with a valid DSN
if (isSentryConfigured) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enabled: import.meta.env.PROD,
  })
}

// NOTE: StrictMode removed — it causes Supabase auth lock contention
// (double useEffect mount) which deadlocks getSession() for 5+ seconds.
// React Strict Mode benefits are not worth the auth UX regression here.
createRoot(document.getElementById('root')!).render(<App />)
